/**
 * AIキャリアアドバイザー機能の表示名
 */
export const INTERVIEW_TRAINING_FEATURE_NAME = 'AI面接対策' as const;

export const INTERVIEW_TRAINING_TITLE_COMPANY_SELECT =
  `面接練習 - ${INTERVIEW_TRAINING_FEATURE_NAME}` as const;
export const INTERVIEW_TRAINING_DESCRIPTION_COMPANY_SELECT =
  'AIを活用した面接練習で選考対策を行いましょう。企業・職種ごとに特化した面接シミュレーションで実践的なスキルを身につけることができます。' as const;

export const INTERVIEW_TRAINING_TITLE_CHAT =
  `面接シミュレーション - ${INTERVIEW_TRAINING_FEATURE_NAME}` as const;
export const INTERVIEW_TRAINING_DESCRIPTION_CHAT =
  'AIとの面接シミュレーションで本番に向けた準備を行いましょう。リアルな面接体験を通じて自信を持って選考に臨むことができます。' as const;

export const INTERVIEW_TRAINING_TITLE_RESULT =
  `面接結果 - ${INTERVIEW_TRAINING_FEATURE_NAME}` as const;
export const INTERVIEW_TRAINING_DESCRIPTION_RESULT =
  '面接練習の結果と詳細なフィードバックをご確認いただけます。改善点や強みを把握し、次回の面接に活かしましょう。' as const;
